import { useMemo } from 'react';
import { useIntl } from 'react-intl';

import { connectFC } from '../../../utils/connectFC';
import { PromotionUpliftStatsFC, PromotionUpliftStatsFCProps } from './PromotionUpliftStatsFC';

export enum StatNotAvailableReason {
  Bolt_Plus_Launch_Test = 'bolt_plus_launch_test',
  Other = 'other',
}

const useStrings = (): PromotionUpliftStatsFCProps['strings'] => {
  const intl = useIntl();
  return useMemo(
    () => ({
      weeklySpend: intl.formatMessage({ id: 'components.PromotionUpliftStats.weeklySpend' }),
      weeklyImpact: intl.formatMessage({ id: 'components.PromotionUpliftStats.weeklyImpact' }),
      impactedUsersText: intl.formatMessage({
        id: 'components.PromotionUpliftStats.impactedUsersText',
      }),
      impactedGMVText: intl.formatMessage({
        id: 'components.PromotionUpliftStats.impactedGMVText',
      }),
      weeklyImpactTipText: intl.formatMessage({
        id: 'components.PromotionUpliftStats.weeklyImpactTipText',
      }),
      statsNotAvailableStrings: {
        [StatNotAvailableReason.Other]: {
          title: intl.formatMessage({
            id: 'components.PromotionUpliftStats.noStatsAvailableTitle',
          }),
          subtitle: intl.formatMessage({
            id: 'components.PromotionUpliftStats.noStatsAvailableSubTitle',
          }),
        },
        [StatNotAvailableReason.Bolt_Plus_Launch_Test]: {
          title: intl.formatMessage({
            id: 'components.PromotionUpliftStats.noStatsAvailableTitle',
          }),
          subtitle: intl.formatMessage({
            id: 'components.PromotionUpliftStats.noStatsAvailableBoltPlusSubTitle',
          }),
        },
      },
    }),
    [intl],
  );
};

export type PromotionUpliftStatsProps = Omit<PromotionUpliftStatsFCProps, 'strings'>;

export const PromotionUpliftStats = connectFC(
  PromotionUpliftStatsFC,
  (props: PromotionUpliftStatsProps) => {
    const strings = useStrings();
    return { ...props, strings };
  },
);
